import React, { useState } from "react";
import "./SkillDropdown.css";

const skills = [
  "Adaptability",
  "Critical Thinking",
  "Emotional Intelligence",
  "Empathy",
  "Problem-Solving",
  "Creativity",
  "Time Management",
  "Decision Making",
  "Conflict Resolution",
  "Active Listening",
  "Interpersonal Skills",
  "Resilience",
  "Self-Motivation",
  "Patience",
  "Work Ethic",
  "Stress Management",
  "Networking",
  "Team Collaboration",
  "Public Speaking",
  "Persuasion",
  "Diplomacy",
  "Attention to Detail",
  "Goal Setting",
  "Strategic Thinking",
  "Innovation",
  "IT Support",
  "Technical Writing",
  "Data Governance",
  "Cyber Risk Management",
  "Cloud Computing Architecture",
  "Data Engineering",
  "Quantum Computing",
  "Edge Computing",
  "AI Ethics",
  "Virtualization",
  "Market Segmentation",
  "Customer Retention",
  "Media Buying",
  "Public Relations",
  "Event Planning",
  "Brand Storytelling",
  "Customer Insights",
  "Business Strategy",
  "Business Development",
  "Competitive Intelligence",
  "Franchise Management",
  "Lean Startup",
  "Product Lifecycle Management",
  "Supply Chain Optimization",
  "Motion Design",
  "Industrial Design",
  "Service Design",
  "User Interface Engineering",
  "Mechatronics",
  "Structural Dynamics",
  "Energy Systems Engineering",
  "Biomechanics",
  "Clinical Research",
  "Patient Care",
  "Health Informatics",
  "Medical Coding",
  "Pharmacy Management",

  "Curriculum Development",
  "Educational Technology",
  "Classroom Management",
  "Special Education",
  "Early Childhood Education",

  "Multilingual Communication",
  "Sign Language",
  "Language Interpretation",
  "Project Management",
  "Software Project Management",
  "Project Management Office (PMO)",
  "Agile Project Management",
  "Project Portfolio Management",
  "Program Management",
  "Web Project Management",
  "Logistics Management",
  "Project Management Body of Knowledge (PMBOK)",
  "JavaScript",
  "Python",
  "Java",
  "C++",
  "React",
  "Node.js",
  "Data Analysis",
  "Machine Learning",
  "Communication",
  "Leadership",
  "Teamwork",
  "SQL",
  "NoSQL",
  "DevOps",
  "Docker",
  "Kubernetes",
  "AWS",
  "Azure",
  "HTML",
  "CSS",
  "Graphic Design",
  "UI/UX Design",
  "Digital Marketing",
  "SEO",
  "Content Creation",
  "Angular",
  "Vue.js",
  "Sass",
  "LESS",
  "TypeScript",
  "Swift",
  "Kotlin",
  "Go",
  "Rust",
  "PHP",
  "Ruby on Rails",
  "ASP.NET",
  "MongoDB",
  "PostgreSQL",
  "MySQL",
  "Oracle",
  "GraphQL",
  "REST API",
  "SOAP",
  "Microservices",
  "Google Cloud Platform",
  "CI/CD",
  "Jenkins",
  "Git",
  "GitHub",
  "Bitbucket",
  "Version Control",
  "Agile",
  "Scrum",
  "Kanban",
  "TDD",
  "BDD",
  "System Design",
  "Software Architecture",
  "Web Development",
  "Mobile Development",
  "Responsive Design",
  "Cross-Platform Development",
  "Full Stack Development",
  "Backend Development",
  "Frontend Development",
  "Serverless Computing",
  "Blockchain",
  "Smart Contracts",
  "Cybersecurity",
  "Ethical Hacking",
  "Penetration Testing",
  "Network Security",
  "Cryptography",
  "Data Encryption",
  "Information Security",
  "Cloud Security",
  "Threat Modeling",
  "Incident Response",
  "Malware Analysis",
  "Vulnerability Assessment",
  "Deep Learning",
  "Natural Language Processing",
  "Computer Vision",
  "Big Data",
  "Hadoop",
  "Spark",
  "Data Warehousing",
  "ETL",
  "Data Mining",
  "Data Visualization",
  "Power BI",
  "Tableau",
  "QlikView",
  "Excel",
  "Statistics",
  "R",
  "Matlab",
  "TensorFlow",
  "PyTorch",
  "Scikit-learn",
  "Keras",
  "Pandas",
  "NumPy",
  "Matplotlib",
  "Seaborn",
  "D3.js",
  "Apache Kafka",
  "Apache Flink",
  "ElasticSearch",
  "Waterfall Project Management",
  "Lean Project Management",
  "Six Sigma",
  "Scrum Master",
  "Product Management",
  "Portfolio Management",
  "Risk Management",
  "Change Management",
  "Stakeholder Management",
  "Business Analysis",
  "Requirements Gathering",
  "Process Improvement",
  "Workflow Automation",
  "Strategic Planning",
  "Budgeting",
  "Financial Analysis",
  "Financial Modeling",
  "Accounting",
  "Bookkeeping",
  "Auditing",
  "Taxation",
  "Corporate Finance",
  "Investment Management",
  "Mergers and Acquisitions",
  "Supply Chain Management",
  "Procurement",
  "Inventory Management",
  "Vendor Management",
  "Operations Management",
  "Human Resources",
  "Talent Acquisition",
  "Employee Relations",
  "Performance Management",
  "Compensation and Benefits",
  "Training and Development",
  "Organizational Development",
  "Compliance",
  "Labor Law",
  "Diversity and Inclusion",
  "Conflict Resolution",
  "Team Management",
  "Negotiation",
  "Public Speaking",
  "Customer Service",
  "Customer Relationship Management",
  "Sales",
  "B2B Sales",
  "B2C Sales",
  "Sales Strategy",
  "Lead Generation",
  "Market Research",
  "Competitive Analysis",
  "Marketing",
  "SEM",
  "Content Marketing",
  "Social Media Marketing",
  "Email Marketing",
  "Affiliate Marketing",
  "Influencer Marketing",
  "Brand Management",
  "Product Marketing",
  "Marketing Analytics",
  "Google Analytics",
  "Adobe Analytics",
  "Conversion Rate Optimization",
  "Customer Journey Mapping",
  "UX Research",
  "Web Design",
  "Mobile App Design",
  "Interaction Design",
  "Visual Design",
  "Prototyping",
  "Wireframing",
  "Adobe Photoshop",
  "Adobe Illustrator",
  "Adobe XD",
  "Sketch",
  "Figma",
  "InVision",
  "Canva",
  "CorelDRAW",
  "3D Modeling",
  "3D Animation",
  "Blender",
  "AutoCAD",
  "SolidWorks",
  "3ds Max",
  "Maya",
  "Cinema 4D",
  "Video Editing",
  "Adobe Premiere Pro",
  "Final Cut Pro",
  "DaVinci Resolve",
  "Avid Media Composer",
  "Motion Graphics",
  "Adobe After Effects",
  "Visual Effects (VFX)",
  "Storyboarding",
  "Photography",
  "Photo Editing",
  "Lightroom",
  "Digital Painting",
  "Illustration",
  "Character Design",
  "Typography",
  "Logo Design",
  "Brand Identity",
  "Print Design",
  "Packaging Design",
  "Game Design",
  "Level Design",
  "Sound Design",
  "Music Production",
  "Audio Editing",
  "Podcasting",
  "Voice Acting",
  "Creative Writing",
  "Copywriting",
  "Technical Writing",
  "Content Strategy",
  "Blogging",
  "Editing",
  "Proofreading",
  "Translation",
  "Localization",
  "E-learning",
  "Instructional Design",
  "Civil Engineering",
  "Structural Engineering",
  "Mechanical Engineering",
  "Electrical Engineering",
  "Electronics Engineering",
  "Chemical Engineering",
  "Industrial Engineering",
  "Manufacturing Engineering",
  "Aerospace Engineering",
  "Automotive Engineering",
  "Biomedical Engineering",
  "Environmental Engineering",
  "Geotechnical Engineering",
  "Materials Science",
  "Metallurgy",
  "Nanotechnology",
  "Robotics",
  "Automation",
  "CAD",
  "CAM",
  "CAE",
  "Product Design",
  "Product Development",
  "Quality Assurance",
  "Quality Control",
  "Reliability Engineering",
  "Safety Engineering",
  "Systems Engineering",
  "Control Systems",
  "Instrumentation",
  "Power Systems",
  "Telecommunications",
  "Wireless Communications",
  "Network Engineering",
  "Circuit Design",
  "PCB Design",
  "FPGA",
  "VHDL",
  "Verilog",
  "Embedded Systems",
  "IoT",
  "Smart Devices",
  "Sensor Networks",
  "Energy Management",
  "Renewable Energy",
  "Sustainable Design",
  "Building Information Modeling (BIM)",
  "Revit",
  "Architecture",
  "Urban Planning",
  "Landscape Architecture",
  "Interior Design",
  "HVAC",
  "Plumbing",
  "Fire Protection",
  "Lighting Design",
  "Construction Management",
  "Surveying",
  "Geographic Information Systems (GIS)",
  "Remote Sensing",
  "Hydrology",
  "Environmental Impact Assessment",
];
import Input from "../Input/Input";
const SkillDropdown = ({ PrevSkills, SetSkills }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredSkills, setFilteredSkills] = useState(skills);
  const [selectedSkills, setSelectedSkills] = useState(PrevSkills);
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setFilteredSkills(
      skills.filter((skill) =>
        skill.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  const handleSkillSelect = (skill) => {
    const newArray = [...selectedSkills, skill];
    setSelectedSkills([...new Set(newArray)]);
    SetSkills([...new Set(newArray)]);
    setSearchTerm("");
  };

  return (
    <div className="dropdown-container">
      <Input
        label="Skills:"
        type="text"
        id="Skills"
        name="Skills"
        value={searchTerm}
        onChangeFunction={handleSearchChange}
      />
      {searchTerm && (
        <div className="dropdown-list">
          {filteredSkills.map((skill, index) => (
            <div
              key={index}
              className="dropdown-item"
              onClick={() => handleSkillSelect(skill)}
            >
              {skill}
            </div>
          ))}
        </div>
      )}
      {selectedSkills && (
        <div className="selected-skill">
          Selected Skills:{" "}
          {selectedSkills.map((skill) => {
            return (
              <div className="Skill" key={skill}>
                <span>{skill}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SkillDropdown;
